import React from 'react';
import classes from './Ftmenu.module.scss';
import { Prof } from '../VectorIcon';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowUpRightFromSquare,faGift,faHands} from "@fortawesome/free-solid-svg-icons";

interface FtmenuProps {
  className?: string;
  classes?: {
    root?: string;
  };
  children?: React.ReactNode;
}

export const Ftmenu = ({ children }: FtmenuProps) => {
  return (
    <div className={`${classes.root} ${classes.menu}`}>
      {children} 
    </div>
  );
};

export　const LINKICON = ({ className = '' }) => {
  return (
    <Ftmenu>
      <a href='https://profcard.info/u/bCet7bWb89Mt9TB25IMaqS990rk1' target='_blank'rel="noreferrer">
      <p className={classes.center}><Prof className={classes.icon} /></p>
      <div className={classes.unnamed}>プロフカード
      <span><FontAwesomeIcon icon={faArrowUpRightFromSquare}/></span></div>
      </a>
      </Ftmenu>);};

export　const LINKICON2 = ({ className = '' }) => {
  return (
    <Ftmenu>
      <a href='https://wavebox.me/wave/5eal2mj0ivft4iy1/' target='_blank'rel="noreferrer">
      <p className={classes.center} style={{color:"#fcc842"}}><FontAwesomeIcon icon={faHands}className={classes.icon}/></p>
      <div className={classes.unnamed}>拍手
      <span><FontAwesomeIcon icon={faArrowUpRightFromSquare}/></span></div>
      </a>
      </Ftmenu>);};
export　const LINKICON3 = ({ className = '' }) => {
  return (
    <Ftmenu>
      <a href='https://giftee.com/u/888m' target='_blank'rel="noreferrer">
      <p className={classes.center} style={{color:"#dc3545"}}><FontAwesomeIcon icon={faGift}className={classes.icon}/></p>
      <div className={classes.unnamed}>差し入れ
      <span><FontAwesomeIcon icon={faArrowUpRightFromSquare}/></span></div>
      </a>
      </Ftmenu>);};